import {resolveBackground} from '#core/utils/color-utils.js';

import {generateBorder} from '#core/application/modules/tiles/border/index.js';
import {
    generateEventCardBadge,
    generateEventCardBadgeRow,
} from '#core/application/modules/tiles/event-card-badge/index.js';
import {generateOddsButton} from '#core/application/modules/tiles/odds-button/index.js';

export function propCardsFactory(PALETTE) {
    return {
        PropCard: {
            container: {
                style: {
                    ...resolveBackground(PALETTE.PROP_CARD_CONTAINER_BG),
                    ...generateBorder(PALETTE.PROP_CARD_BORDER),
                },
            },
            badgeRow: generateEventCardBadgeRow(PALETTE.PROP_EVENT_CARD_BADGE),
            categoryBadge: generateEventCardBadge(PALETTE.PROP_EVENT_CARD_BADGE),
            headerSection: {
                style: {
                    ...resolveBackground(PALETTE.PROP_CARD_HEADER_SECTION_BG),
                    justifyContent: 'center',
                    minHeight: '40px',
                    padding: '6px 10px 4px',
                },
            },
            marketSection: {
                style: {
                    ...resolveBackground(PALETTE.PROP_CARD_MARKET_SECTION_BG),
                    minHeight: '20px',
                    padding: '0 10px 4px',
                },
            },
            jerseySection: {
                style: {
                    ...resolveBackground(PALETTE.PROP_CARD_JERSEY_SECTION_BG),
                },
            },
            matchSection: {
                style: {
                    ...resolveBackground(PALETTE.PROP_CARD_MATCH_SECTION_BG),
                    minHeight: '22px',
                    padding: '4px 8px 0',
                },
            },
            footerSection: {
                style: {
                    ...resolveBackground(PALETTE.PROP_CARD_FOOTER_SECTION_BG),
                    alignItems: 'stretch',
                    minHeight: '48px',
                    padding: '6px 8px 8px',
                },
            },
            playerNameLabel: {
                style: PALETTE.PLAYER_NAME_TEXT,
            },
            marketNameLabel: {
                style: PALETTE.MARKET_NAME_TEXT,
            },
            participantsInline: {
                participantIcons: {
                    showParticipantIcons: false,
                },
                participantName: {
                    style: PALETTE.PARTICIPANT_NAME_TEXT,
                },
                separator: {
                    style: PALETTE.PARTICIPANT_NAME_TEXT,
                },
            },
            eventNameLabel: {
                style: PALETTE.EVENT_NAME_TEXT,
            },
            selectionButton: generateOddsButton(PALETTE.ODDS_BUTTON),
        },
    };
}
